var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadmoreLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(255, 255, 255, 0)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "118px",
    height: "30px",
    viewBox: "0 0 100 60",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 42.5,
    width: 19,
    height: 15,
    fill: "#0f3d3e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "35;42.5;42.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.13333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "30;15;15",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.13333333333333333s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 42.5,
    width: 19,
    height: 15,
    fill: "#e2dcc8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "36.875;42.5;42.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.06666666666666667s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "26.25;15;15",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.06666666666666667s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 42.5,
    width: 19,
    height: 15,
    fill: "#100f0f"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "36.875;42.5;42.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.6666666666666666s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "26.25;15;15",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadmoreLoader);
export default __webpack_public_path__ + "static/media/loadmoreLoader.4c341217b87a998f3b172ef98eb01e62.svg";
export { ForwardRef as ReactComponent };